import { api } from '~/services/api';
import { AxiosError } from 'axios';

type LineWaitTimeParams = {
  unit_id: string;
  people: number;
  line_position: number;
};

export type LineWaitTimeProps = {
  wait_time_in_minutes: number[];
};

type GetLineWaitTimeProps = {
  data?: LineWaitTimeProps;
  status?: number;
  message?: string;
};

type LineWaitTimeOptions = {
  onSuccess?: (data: GetLineWaitTimeProps) => void;
  onError?: (data: AxiosError) => void;
};

export const getLineWaitTime = async (
  params?: LineWaitTimeParams
): Promise<GetLineWaitTimeProps> => {
  try {
    const { unit_id, line_position, people } = params as LineWaitTimeParams;
    const { data, status } = await api.post(
      `/line/v1/units/${unit_id}/predictions/wait-time`,
      {
        line_position,
        people,
      }
    );

    return {
      data: data,
      status,
    };
  } catch (err) {
    const error = err as AxiosError;

    return {
      message: (error.response?.data as any).message,
      status: error.response?.status,
    };
  }
};
